import { useEffect, useState } from "react";
import { Dialog, DialogContent, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { VisuallyHidden } from "@radix-ui/react-visually-hidden";
import trofeos from "@/assets/trofeos-lags.jpg";

export const TrophyPopup = () => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const checkHash = () => {
      if (window.location.hash === "#cursos") {
        setOpen(true);
      }
    };
    checkHash();
    window.addEventListener("hashchange", checkHash);
    return () => window.removeEventListener("hashchange", checkHash);
  }, []);

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent className="max-w-3xl p-0 overflow-hidden border-gold/40 bg-background">
        <VisuallyHidden>
          <DialogTitle>Trofeos Campeonato de España LAGS</DialogTitle>
          <DialogDescription>Galería de trofeos obtenidos por Federico Duronio</DialogDescription>
        </VisuallyHidden>
        <img
          src={trofeos}
          alt="Trofeos Campeonato de España LAGS 2024, 2025 y 2026"
          className="w-full h-auto object-contain"
        />
      </DialogContent>
    </Dialog>
  );
};
